import { Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as SX from './sx';
import type { PlanTaglineProps as Props } from './types';

export const PlanTagline = memo(({ className }: Props) => {
  const { config } = usePlanCardContext();
  const tagline = config?.tagline?.trim();

  if (!tagline) return null;

  return (
    <Label
      className={classnames('PlanTagline', className)}
      sx={SX.root}
      variant="soft"
      color="primary"
      size="xsmall"
    >
      {tagline}
    </Label>
  );
});

PlanTagline.displayName = 'PlanTagline';
